import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Callout, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { isFutureEffectiveDate } from '~/business-logic/billingLogic';
import { StepPage } from '~/client-flow/components/StepPage';
import { useResponsive } from '~/client-flow/contexts';
import { useIoContext, useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { relationshipModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import { COBStep, getStepName, stepsTextsPath } from '../ClientOnboarding.utils';
import { useCobConfig } from '../CobConfigContext';
import PackageSelector from './PackageSelector';
import styles from './PackagesStep.module.scss';
export const { PackagesStepTestIds } = getTestIds();
export default function PackagesStep(param) {
    let { selectedBundleID, onSelectBundleID, onClickNext, onClickBack } = param;
    var _ref;
    var _relationship_serviceBundles;
    const { isMobile } = useResponsive();
    const { t: packagesTexts } = useLocaleKeys('clientFlow.packagesStep');
    const { t: stepsTexts } = useLocaleKeys(stepsTextsPath);
    const { relationship } = useCobConfig();
    const { getNow } = useIoContext();
    const userId = useStore(selectors.user.id);
    const isBuyer = relationshipModel.isBuyer(relationship, userId);
    const hasSignatories = relationshipModel.hasSignatories(relationship);
    return /*#__PURE__*/ _jsxs(StepPage, {
        header: getStepName(COBStep.selectAPackage, relationship, stepsTexts),
        primaryBtn: /*#__PURE__*/ _jsx(Button, {
            bi: {
                name: 'packages_step_next'
            },
            onClick: ()=>onClickNext(),
            children: packagesTexts.next()
        }),
        onBackBtnClick: onClickBack,
        testId: PackagesStepTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.sectionTitle,
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "h6",
                    weight: "normal",
                    children: "Packages"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.onlyPrimaryCanSelectCallout,
                children: [
                    !isBuyer && hasSignatories && /*#__PURE__*/ _jsx("div", {
                        className: styles.onlyPrimaryCanSelectCalloutContent,
                        children: /*#__PURE__*/ _jsxs(Callout, {
                            testId: "select-package-disabled-callout",
                            children: [
                                "Only ",
                                relationshipModel.buyerFullName(relationship),
                                " can select package for this proposal"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(PackageSelector, {
                        packages: (_ref = (_relationship_serviceBundles = relationship.serviceBundles) === null || _relationship_serviceBundles === void 0 ? void 0 : _relationship_serviceBundles.bundles) !== null && _ref !== void 0 ? _ref : [],
                        isEffectiveDateInFuture: isFutureEffectiveDate(relationship === null || relationship === void 0 ? void 0 : relationship.effectiveDate, getNow()),
                        selectedBundleID: selectedBundleID,
                        isMobile: isMobile,
                        onSelect: (id)=>onSelectBundleID(id)
                    })
                ]
            })
        ]
    });
}
